import type { CitationResponse, MediaAssetResponse } from 'we-tree-api-client/v2';
import type { MediaLibraryFilters } from '@/types/media-library';

export function buildMediaAssetSourceMap(citations: CitationResponse[]): Map<string, Set<string>> {
  const map = new Map<string, Set<string>>();
  for (const citation of citations) {
    if (!citation.mediaAssetId) continue;
    const existing = map.get(citation.mediaAssetId) ?? new Set<string>();
    existing.add(citation.sourceId);
    map.set(citation.mediaAssetId, existing);
  }
  return map;
}

export function collectMediaYears(assets: MediaAssetResponse[]): number[] {
  const years = new Set<number>();
  for (const asset of assets) {
    const year = new Date(asset.createdAt).getFullYear();
    if (!Number.isNaN(year)) years.add(year);
  }
  return [...years].sort((a, b) => b - a);
}

export function filterMediaAssets(
  assets: MediaAssetResponse[],
  filters: MediaLibraryFilters,
  mediaSourceMap: Map<string, Set<string>>
): MediaAssetResponse[] {
  let result = assets;

  if (filters.year !== 'all') {
    const year = Number(filters.year);
    if (!Number.isNaN(year)) {
      result = result.filter((asset) => new Date(asset.createdAt).getFullYear() === year);
    }
  }

  if (filters.sourceId !== 'all') {
    result = result.filter((asset) => mediaSourceMap.get(asset.id)?.has(filters.sourceId));
  }

  return result;
}

export function hasActiveMediaLibraryFilters(filters: MediaLibraryFilters): boolean {
  return filters.year !== 'all' || filters.sourceId !== 'all';
}
